export default __webpack_public_path__ + "55afd361ade597518b66b6d25956c392.png";